export const BANNER_TEXT1 =
  "We'll use this information to get in touch with you. Please ensure you enter all details accurately. ";
export const COUNTRY_CODE = "44";
export const BANNER_TEXT2 =
  "If we need to send you any legal documentation in relation to your Pay as you Grow choice this will be sent to you in an encrypted email and we will use the mobile number you provide below to send you the access code.";
